// extracted by mini-css-extract-plugin
export var newsContainer = "news-module--newsContainer--ex60g";